import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeowners = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.65 3.87a2 2 0 0 1 2.7 0l10 9.09.01.01a2.04 2.04 0 0 1 .64 1.45V26h2a1 1 0 1 1 0 2H2a1 1 0 1 1 0-2h2V14.42a2.04 2.04 0 0 1 .64-1.45l.01-.01 10-9.09ZM14 26h4v-6h-4v6Zm6 0v-6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6H6V14.45a.04.04 0 0 1 0-.02l10-9.08 10 9.08V26h-6Z"
	})
});
export default SvgHomeowners;
